// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__ghMzV","title":"AfterFrontImage_title__2oD5s"};